const LEGAL_DOCUMENT_TYPES = {
  terms: "terms",
  privacy: "privacy",
};

export default LEGAL_DOCUMENT_TYPES;
